module.exports = __webpack_public_path__ + "img/deviceControl.dd9f7053.svg";